let pending;

// Share the download between idle warm-up and navigation. A failed warm-up
// must not poison the route: the next attempt starts a fresh import.
export function loadProductPage() {
  if (!pending) {
    pending = import("../ProductDetails").catch(error => {
      pending = undefined;
      throw error;
    });
  }
  return pending;
}

export function scheduleProductPageWarmup(load = loadProductPage, host = window) {
  const connection = host.navigator?.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || "")) return () => {};
  let cancelled = false;
  let idle;
  let frame;
  const start = () => {
    if (!cancelled) load().catch(() => {});
  };
  // Give the menu a paint before spending bandwidth/CPU on the next route.
  frame = host.requestAnimationFrame(() => {
    frame = host.requestAnimationFrame(() => {
      idle = host.requestIdleCallback
        ? host.requestIdleCallback(start, { timeout: 1500 })
        : host.setTimeout(start, 250);
    });
  });
  return () => {
    cancelled = true;
    host.cancelAnimationFrame(frame);
    if (host.requestIdleCallback && host.cancelIdleCallback) host.cancelIdleCallback(idle);
    else host.clearTimeout(idle);
  };
}
